<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">{{isCreate ? `Add ${page}` : `Edit ${page}`}}</h2>
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="#" @click="$router.go(-1)">Back</a></li>
          <li class="breadcrumb-item active" aria-current="page">{{isCreate ? `Add ${page}`  : `Edit ${page}`}}</li>
        </ol>
      </div>
      <div class="d-flex">
      </div>
    </div>
    <div class="row row-sm justify-content-center">
      <div class="col-xl-7 col-lg-8 col-md-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">Page</h6>
            </div>
            <div v-if="showVideo === true">
              <ValidationObserver ref="currencyAddForm" id="currencyAddForm" tag="form" class="d-flex flex-column" @submit.prevent="formSubmit()">
                <b-tabs content-class="mt-3">
                  <b-tab :title="language.code" v-for="(language, i) in languages" :key="i">
                    <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                      <label :for="'name[' + language.code + ']'" class="form-label">Answer:</label>
                      <textarea :id="'name[' + language.code + ']'" class="form-control" :name="'answer_l[' + language.code + ']'" v-model="formData.answer_l[language.code]" :class="checkValidation(classes, language.code)" placeholder="Answer"></textarea>
                    </ValidationProvider>
                    <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                      <label :for="'question_l[' + language.code + ']'" class="form-label">Question:</label>
                      <textarea :id="'question_l[' + language.code + ']'" class="form-control" :name="'question_l[' + language.code + ']'" v-model="formData.question_l[language.code]" :class="checkValidation(classes, language.code)" placeholder="Question"></textarea>
                    </ValidationProvider>
                  </b-tab>
<!--                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">-->
<!--                    <label for="continent_id" class="form-label">Page:</label>-->
<!--                    <multiselect v-model="formData.page" placeholder="Select Page" id="continent_id" :custom-label="customLabel" :class="classes" lable="slug"  :close-on-select="true" track-by="id" :options="pages">-->
<!--                      <template slot="singleLabel" slot-scope="props">-->
<!--                        {{props.option.slug}}-->
<!--                      </template>-->
<!--                      <template slot="option" slot-scope="props">-->
<!--                        <span class="option__name">{{props.option.slug}}</span>-->
<!--                      </template>-->
<!--                    </multiselect>-->
<!--                  </ValidationProvider>-->
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label class="form-label" for="ajax">Page:</label>
                    <multiselect v-model="formData.page" id="ajax" label="name" track-by="code" :custom-label="customLabel" placeholder="Select Page" :class="classes" open-direction="bottom" :options="pages" :searchable="true" :loading="isLoading" :internal-search="false" :clear-on-select="false" :close-on-select="false" :options-limit="300" :limit="3" :limit-text="limitText" :max-height="600" :show-no-results="false" :hide-selected="true" @search-change="asyncFind">
                      <template slot="singleLabel" slot-scope="props">
                        {{props.option.slug}}
                      </template>
                      <template slot="option" slot-scope="props">
                        <span class="option__name">{{props.option.slug}}</span>
                      </template>
                      <span slot="noResult">Oops! No elements found. Consider changing the search query.</span>
                    </multiselect>
                  </ValidationProvider>
                </b-tabs>
                <button class="btn ripple btn-main-primary mt-2" :disabled="buttonDisable" :class="buttonDisable ? 'button-readonly' : ''">Submit</button>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
const page = 'faq'
export default {
  name: 'FaqAdd',
  data () {
    return {
      page: page,
      showVideo: false,
      isEdit: false,
      buttonDisable: false,
      isLoading: false,
      pages: [],
      selectedCountries: [],
      countries: [],
      formData: {
        answer_l: {},
        question_l: {}
      },
      isCreate: false,
      cookieId: ''
    }
  },
  computed: {
    ...mapState({
      languages: state => state.language.languages,
      itemData: state => state[page].itemData
    })
  },
  created () {
    this.cookieId = this.$route.params.id
    if (this.cookieId === 'add') {
      this.isEdit = false
      this.isCreate = true
      this.showVideo = true
    } else {
      this.isEdit = true
      this.getData({ id: this.cookieId }).then(res => {
        this.showVideo = true
        this.formData = this.itemData
      })
    }
    this.getCreateData().then((res) => {
      this.pages = res
    })
  },
  methods: {
    ...mapActions({
      create: page + '/create',
      update: page + '/update',
      getCreateData: page + '/getCreateData',
      getData: page + '/getData'
    }),
    limitText (count) {
      return `and ${count} other countries`
    },
    asyncFind (query) {
      this.isLoading = true
      this.getCreateData(query).then(response => {
        this.pages = response
        this.isLoading = false
      })
    },
    clearAll () {
      this.selectedCountries = []
    },
    customLabel (data) {
      return `${data.slug}`
    },
    checkValidation (data) {
      return data
    },
    formSubmit () {
      this.$refs.currencyAddForm.validate().then(success => {
        if (success) {
          this.buttonDisable = true
          this.formData.page_id = this.formData.page.id
          if (this.isCreate === true) {
            this.create(this.formData).then(() => {
              this.$toasted.success(this.$t('messages.success.courseCreated')).goAway(1500)
              this.$router.push('/' + page)
            }).catch(err => {
              if (err && err.response) {
                if (err.response.status === 422) {
                  const data = err.response.data.errors
                  const keys = Object.keys(data)
                  const msg = data[keys[0]]
                  this.$toasted.error(msg).goAway(1500)
                } else {
                  this.$toasted.error(err.response.message).goAway(1500)
                }
              }
            }).finally(() => {
              this.buttonDisable = false
            })
          } else {
            this.update({ data: this.formData, id: this.$route.params.id }).then(res => {
              this.$toasted.success(this.$t('messages.success.courseUpdated')).goAway(1500)
              this.$router.push('/' + page)
            }).catch(err => {
              if (err && err.response) {
                if (err.response.status === 422) {
                  const data = err.response.data.errors
                  const keys = Object.keys(data)
                  const msg = data[keys[0]]
                  this.$toasted.error(msg).goAway(1500)
                } else {
                  this.$toasted.error(err.response.message).goAway(1500)
                }
              }
            }).finally(() => {
              this.buttonDisable = false
            })
          }
        } else {
          this.$toasted.error(this.$t('messages.error.validationError')).goAway(1500)
        }
      })
    }
  }
}
</script>
